import * as DataProviders from '../../types/data-providers';
import * as SiteManager from '../domain/site-manager';
import React from 'react';
import { useData, dataFromDataset } from './DataProviderCache';
import { useAuthHelper } from '../../components/AuthContextProvider';

type ContextState = DataProviders.Data<number | undefined>;

const Context = React.createContext<ContextState | null>(null);

function useSiteAlarmCount(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useSiteAlarmCount must be used within a SiteAlarmCountProvider');
    }
    return contextState;
}

const SiteAlarmCountProvider: React.FC<{ siteId: string }> = (props) => {
    const authHelper = useAuthHelper();

    const dataObj = useData({
        cacheKey: 'site-alarm-count-data',
        id: props.siteId,
        dataFn: React.useCallback(
            () => SiteManager.getSiteAlarmCount(authHelper, { siteId: props.siteId }),
            [authHelper, props.siteId]
        ),
    });
    const statusData = dataFromDataset(dataObj.dataset);

    return <Context.Provider value={statusData}>{props.children}</Context.Provider>;
};

const TestSiteAlarmCountProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { SiteAlarmCountProvider, TestSiteAlarmCountProvider, useSiteAlarmCount };
